export default "__VITE_ASSET__rw7xE4Vm__"